import { Callout } from '../Docs/Callout/Callout'

export function MissingFrameworkCopy() {
	return (
		<Callout
			content={`If there's a framework that's missing, feel free to [create an issue](https://github.com/highlight/highlight/issues/new?assignees=&labels=external+bug+%2F+request&template=feature_request.md&title=) or message us on [discord](https://highlight.io/community).`}
		/>
	)
}
